import { render } from "./live-music.vue?vue&type=template&id=6e939fe6"
import script from "./live-music.vue?vue&type=script&lang=js"
export * from "./live-music.vue?vue&type=script&lang=js"

import "./live-music.vue?vue&type=style&index=0&id=6e939fe6&lang=scss"

import exportComponent from "C:\\www\\momentum_v2\\momentum\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__